import { render, staticRenderFns } from "./RegisterOnboarding.vue?vue&type=template&id=6802b138&scoped=true"
import script from "./RegisterOnboarding.vue?vue&type=script&lang=js"
export * from "./RegisterOnboarding.vue?vue&type=script&lang=js"
import style0 from "./RegisterOnboarding.vue?vue&type=style&index=0&id=6802b138&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6802b138",
  null
  
)

export default component.exports